import _ from 'lodash';
import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setUserQuickMenus = ({ commit }, data) => {
  commit('SET_USER_MENUS_BREAD_CRUMB', data);
};

export default {
  async GET_USER_MENUS_BREAD_CRUMB(store, param) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/auth/quick-menus`);

    const userMenus = [];
    response.data.forEach(menuId => {
      const menu = _.find(param.quickMenus, ['menuId', menuId]);
      if (menu) {
        menu.selected = true;
        userMenus.push(menu);
      }
    });

    setUserQuickMenus(store, userMenus);
    return response;
  },

  async MODIFY_USER_MENU_BREAD_CRUMB(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/auth/quick-menus`, param);
  },

  async REMOVE_USER_MENUS_BREAD_CRUMB(store, param) {
    await RequestUtil.delete(`${SDLUtil.API_URL}/auth/quick-menus/${param}`);
  },


};



// WEBPACK FOOTER //
// ./src/vuex/common/breadCrumb/breadCrumbActions.js